import React, { FunctionComponent } from 'react';
import { faRing } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconMaritalStatus: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faRing} />;

export { BrassIconMaritalStatus };
